import { gql } from '@apollo/client'

export const BLOG_POSTS_QUERY = gql`
  query blogPosts($filter: BlogPostFilter, $sortBy: BlogPostSort, $limit: Int, $page: Int) {
    blogPosts(filter: $filter, sortBy: $sortBy, limit: $limit, page: $page) {
      collection {
        id
        title
        subtitle
        pinned
        content
        createdAt
        updatedAt
        categories
      }
    }
  }
`
